module.exports = __webpack_public_path__ + "static/media/google-pay.0a6f5926.svg";